import { forwardRef, useCallback, useEffect, useState } from "react";
import AdminInput from "./Controllers/AdminInput";

const RequestAdvisorEditForm = forwardRef(({ data, onSaveChanges }, ref) => {
  const [requestAdvisor, setRequestAdvisor] = useState(data);
  const [saving, setSaving] = useState(false);

  const handleSave = useCallback((ev) => {
    ev.preventDefault();
    setSaving(true);
  }, [setSaving]);

  useEffect(() => {
    if (saving) {
      onSaveChanges(requestAdvisor);
      setSaving(false);
    }
  }, [saving]);

  useEffect(() => {
    setRequestAdvisor(data);
  }, [data]);

  return (
    <form ref={ref} className="p-4" onSubmit={handleSave}>
      <fieldset className="px-2 pb-4 border-2">
        <legend className="p-2 text-2xl">Solicitud de asesoría</legend>
        <div className="p-2">
          <AdminInput isSaving={saving} onChange={setRequestAdvisor} type="text" label="Texto" source={requestAdvisor} path="text" value={requestAdvisor?.text || ""} />
        </div>
      </fieldset>
    </form>
  );
});

export default RequestAdvisorEditForm;
